import { useEffect, useState } from "react";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  TextField,
  MenuItem,
  Button,
} from "@mui/material";
import AlertBox from "components/Alert/alert";
import { getAllContinents } from "services/apiService";
import { sendNotifications } from "services/apiService";

function Notifications() {
  const [audience, setAudience] = useState("Global");
  const [continent, setContinent] = useState([]);
  const [continentId, setContinentId] = useState("");
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [alert, setAlert] = useState({
    open: false,
    type: "success", // "success" | "error" | "confirm"
    title: "",
    message: "",
  });

  useEffect(() => {
    getContinent();
  }, []);

  const getContinent = async () => {
    try {
      const response = await getAllContinents();
      if (response?.success) {
        setContinent(response?.data);
      }
    } catch (err) {
      console.error("Fetch users failed:", err);
    }
  };

  const sendNotification = async () => {
    if (!title.trim()) {
      setAlert({
        open: true,
        type: "error",
        title: "Validation Error",
        message: "Title cannot be empty.",
      });
      return;
    }

    if (!message.trim()) {
      setAlert({
        open: true,
        type: "error",
        title: "Validation Error",
        message: "Message cannot be empty.",
      });
      return;
    }

    try {
      let obj = {
        title: title,
        body: message,
        continentId: continentId,
      };
      const res = await sendNotifications(obj);
      if (res?.success) {
        setAlert({
          open: true,
          type: "success",
          title: "Notification Sent",
          message: res?.message?.message,
        });
      } else {
        setAlert({
          open: true,
          type: "error",
          title: "Validation Error",
          message: res?.message,
        });
      }
    } catch (error) {
      setAlert({
        open: true,
        type: "error",
        title: "Error",
        message: "Failed to send notification. Please try again.",
      });
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <AlertBox
        open={alert.open}
        type={alert.type}
        title={alert.title}
        message={alert.message}
        onClose={() => setAlert({ ...alert, open: false })}
        onConfirm={() => {
          setAlert({ ...alert, open: false });
        }}
      />
      <Box
        p={5}
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="calc(100vh - 150px)" 
      >
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={10} md={10} lg={8}>
            <Card sx={{ width: "100%" }}>
              <CardContent sx={{ padding: 2 }}>
                <Typography variant="h5" mb={2} mt={2} textAlign="center">
                  Send Notification
                </Typography>
                <Box display="grid" gap={3}>
                  <TextField
                    label="Title"
                    fullWidth
                    size="medium"
                    onChange={(e) => {
                      setTitle(e?.target?.value);
                    }}
                  />
                  <TextField
                    label="Message"
                    fullWidth
                    multiline
                    rows={4}
                    size="medium"
                    onChange={(e) => {
                      setMessage(e?.target?.value);
                    }}
                  />
                  <TextField
                    select
                    label="Audience"
                    fullWidth
                    size="medium"
                    value={audience}
                    onChange={(e) => {
                      setContinentId(e?.target?.value?.id);
                      setAudience(e?.target?.value);
                    }}
                    sx={{
                      "& .MuiInputBase-root": {
                        height: 40,
                      },
                    }}
                    SelectProps={{
                      MenuProps: {
                        PaperProps: {
                          style: {
                            maxHeight: 550,
                          },
                        },
                      },
                    }}
                  >
                    <MenuItem value="Global">Global</MenuItem>
                    {continent.map((c) => (
                      <MenuItem key={c} value={c}>
                        {c?.name}
                      </MenuItem>
                    ))}
                  </TextField>
                  <Button
                    variant="contained"
                    size="large"
                    sx={{
                      color: "beige", 
                      fontWeight: "bold",
                    }}
                    onClick={() => sendNotification()}
                  >
                    Send Now
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
      <Footer />
    </DashboardLayout>
  );
}

export default Notifications;
